import React from 'react';
import { Box, Copy, Label, Input, Optional } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import themeStyles from './ApplyForCreditModal.styles';
import VehicleSummaryCard from '../VehicleSummaryCard';
const Container = themeStyles.apply(Box, 'Container');
const InputField = themeStyles.apply(Input, 'InputField');
const DescriptionCopy = themeStyles.apply(Copy, 'DescriptionCopy');
const ApplyForCreditModalContent = ({ vehicle, vehicleImage, modelBadgeImage, bigExteriorImage, isSalesTaxIncluded, onInputFieldChange, inputFieldValue, defaultBuildName, }) => {
    const { t } = useTranslation();
    function handleChange(e) {
        const { value } = e.target;
        onInputFieldChange(value);
    }
    return (React.createElement(Container, { "data-testid": "cy-CreditModal_container" },
        React.createElement(VehicleSummaryCard, { badgeTestId: "cy-ApplyForCreditModal-badge", vehicle, vehicleImage, modelBadgeImage, bigExteriorImage }),
        React.createElement(DescriptionCopy, { size: "regular", "data-testid": "cy-CreditModal_first_description" }, t('Pages.Bap.applyCreditModalLine1Text')),
        React.createElement(Optional, { when: !isSalesTaxIncluded },
            React.createElement(DescriptionCopy, { size: "regular", "data-testid": "cy-CreditModal_second_description" }, t('Pages.Bap.applyCreditModalLine2Text'))),
        React.createElement(Label, { fontFamily: "default", "data-testid": "cy-CreditModal_build_name_label", "aria-label": t('Pages.Bap.buildNameLabel') }, t('Pages.Bap.buildNameLabel')),
        React.createElement(InputField, { maxLength: "50", value: inputFieldValue, onChange: handleChange, "aria-label": t('Pages.Bap.buildNameInputAria'), "data-testid": "cy-CreditModal_build_name_input", placeholder: defaultBuildName })));
};
export default ApplyForCreditModalContent;
